import $ from 'jquery';

$.addInit(function(context){
	var base = '.i-chooseControl';
	$(base, context).each(function(){
		var component = $(this);
		var check = component.find(base + '-check');
		var input = component.find(base + '-input');

		check.on('click', function(e) {
			input.attr("required", !!this.checked)
		});

		input.on('input', function(e) {
			if (e.target.value.length) {
				check.prop('checked', true)
			} else {
				check.prop('checked', false)
			}
		});
	});
});